<template>
  <transition name="fade">
    <!-- eslint-disable -->
    <div
      v-if="visible"
      class="modal detail_box"
    >
      <div
        class="detail"
        style="height:500px;"
      >
        <div class="titles msp_icon_close">
          <span class="title_name">批量修改信息</span>
          <span
            class="iconfont el-icon-close"
            @click.stop="closeBox()"
          />
        </div>
        <div class="detail_el_scroll">
          <div class="bottom_button">
            <div class="bottom_content">
              <el-button
                type="primary"
                @click.native="sureSetMatterInfo()"
              >确定</el-button>
            </div>
          </div>
          <div class="upload_matter_info">

            <div class="upload_each_info_detail upload_input_info_detail">
              <span>标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题：</span>
              <el-input
                placeholder="若标题为空，则视为不修改标题"
                v-model="uploadPicObj.title"
              ></el-input>
            </div>

            <div class="upload_each_info_detail upload_input_tags_detail">
              <span>素材标签：</span>
              <el-cascader
                v-model="uploadPicObj.tagIds"
                :options="tagsTree"
                :props='cascaderProps'
                :size='cascaderSize'
                :show-all-levels="false"
                ref='cascaderref'
                filterable
                @change="handleChange"
              ></el-cascader>
            </div>
            <div class="upload_each_info_detail">
              <span>关&nbsp;&nbsp;键&nbsp;&nbsp;词：</span>
              <div class="key_words">
                <el-tag
                  :key="tag"
                  v-for="tag in uploadPicObj.keywords"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                >
                  {{tag}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="small"
                  maxlength="10"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput"
                >+ 添加关键词</el-button>
              </div>
            </div>
            <div class="upload_each_info_detail upload_input_info_detail">
              <span>素材描述：</span>
              <el-input
                type="textarea"
                placeholder="请填写描述,最多100字"
                v-model="uploadPicObj.detail"
                maxlength="100"
                :show-word-limit='true'
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as api from '../../../api'
export default {
  data () {
    return {
      visible: false,
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        multiple: true,
        emitPath: false,
        checkStrictly: true,
        expandTrigger: 'hover'
      },
      cascaderSize: 'medium',
      inputVisible: false,
      inputValue: '',
      uploadPicObj: {
        'tagIds': [], // 必须参数： 标签ID列表
        'tags': [], // 必须参数： 标签列表
        'keywords': [], // 必须参数： 关键词列表
        'detail': '', // 必须参数： 标题
        'title': ''
      },
      modifyDataList: [],
      modifyDataType: ''
    }
  },
  computed: {
    tagsTree () {
      return this.$store.state.tags.matterTagsTree
    }
  },
  watch: {
    visible () {
      if (this.visible === false) {
        this.inputValue = ''
        this.inputVisible = false
        this.uploadPicObj = {
          'tagIds': [], // 必须参数： 标签ID列表
          'tags': [], // 必须参数： 标签列表
          'keywords': [], // 必须参数： 关键词列表
          'detail': '', // 必须参数： 标题
          'title': ''
        }
      }
    }
  },
  mounted () {
    this.$root.eventHub.$on('batchModifyInfoModel', (dataList, type) => {
      this.visible = true
      this.modifyDataList = dataList
      this.modifyDataType = type
    })
  },
  destroyed () {
    this.$root.eventHub.$off('batchModifyInfoModel')
  },
  methods: {
    closeBox () {
      this.visible = false
    },
    handleChange (val) {
      var node = this.$refs.cascaderref.getCheckedNodes()
      var tags = []
      for (var i = 0; i < node.length; i++) {
        for (var j = 0; j < this.uploadPicObj.tagIds.length; j++) {
          if (node[i].value === this.uploadPicObj.tagIds[j]) {
            tags.push(node[i].label)
          }
        }
      }
      this.uploadPicObj.tags = tags
    },
    handleClose (tag) {
      this.uploadPicObj.keywords.splice(this.uploadPicObj.keywords.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.uploadPicObj.keywords.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    sureSetMatterInfo () {
      var arr = []
      var currentChoiceMatter = []
      var titleArr = []
      for (var i = 0; i < this.modifyDataList.length; i++) {
        if (this.modifyDataList[i].isChoice) {
          for (var key in this.uploadPicObj) {
            if (this.modifyDataList[i].hasOwnProperty(key)) {
              if (key !== 'title') {
                this.$set(this.modifyDataList[i], key, this.uploadPicObj[key])
              }
            }
          }
          if (this.modifyDataList[i].id) {
            arr.push(this.modifyDataList[i].id)
          }
          currentChoiceMatter.push(this.modifyDataList[i])
        }
      }

      if (this.uploadPicObj.title) {
        for (var j = 0; j < currentChoiceMatter.length; j++) {
          for (var n = 0; n < this.modifyDataList.length; n++) {
            if (currentChoiceMatter[j].url === this.modifyDataList[n].url) {
              this.$set(this.modifyDataList[n], 'title', this.uploadPicObj.title + '【' + (j + 1) + '】')
            }
          }
        }
      }

      for (var m = 0; m < this.modifyDataList.length; m++) {
        if (this.modifyDataList[m].isChoice) {
          titleArr.push({
            id: this.modifyDataList[m].id,
            title: this.modifyDataList[m].title,
            type: this.modifyDataList[m].type
          })
        }
      }

      if (this.modifyDataType === 'picture' || this.modifyDataType === 'video' || this.modifyDataType === 'audio' || this.modifyDataType === 'file') {
        var apiType = ''
        var option = {
          ...this.$store.getters.baseOption,
          params: {
            keywords: this.uploadPicObj.keywords,
            tags: this.uploadPicObj.tags,
            tagIds: this.uploadPicObj.tagIds,
            detail: this.uploadPicObj.detail,
            ids: arr,
            type: this.modifyDataType
          }
        }

        var optiontwo = {
          ...this.$store.getters.baseOption,
          params: {
            info: titleArr
          }
        }

        if (this.modifyDataType === 'video' || this.modifyDataType === 'audio') {
          apiType = _VIDEOAUDIOURL_
        } else if (this.modifyDataType === 'picture' || this.modifyDataType === 'file') {
          apiType = _IMGFILEURL_
        }
        this.changeInfoLoading = true
        api._post(apiType + 'public/edit_title', optiontwo).then((resp) => {
          if (resp.code === 200) {
            this.changeTitleinfo(apiType, option)
          }
        }).catch((error) => {
          console.log(error)
          this.changeInfoLoading = false
        })

      } else {
        this.visible = false
      }

    },
    changeTitleinfo (apiType, option) {
      api._post(apiType + 'public/editInfo', option).then((resp) => {
        if (resp.code === 200) {
          this.$notify.success({
            title: '成功',
            message: '修改成功'
          })
          this.changeInfoLoading = false
          this.visible = false
        }
      }).catch((error) => {
        console.log(error)
        this.changeInfoLoading = false
      })

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/modifyInfo.styl'
</style>
